import React, { useEffect, useState } from 'react';
import { Form } from 'react-final-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createSelector } from 'reselect';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import SurveyCompleteForm from '../../components/change-insights/SurveyCompleteForm.jsx';
import SubHeader from '../../components/SubHeader.jsx';
import { selectCurrentOrganizationId } from '../../modules/auth.js';
import {
  applyChangeInsight,
  deleteSurveyFromInitiative,
  retrieveChangeInsight,
  retrieveTemplatesFeedbackForm,
  selectTemplates,
  sendChangeInsightSurvey,
  sendResponseSurvey,
} from '../../modules/changeInsights.js';
import {
  retrieveInitiative,
  selectInitiative,
} from '../../modules/initiatives.js';
import {
  retrieveOrganization,
  selectOrganization,
} from '../../modules/organizations.js';
import { retrieveSurveyResponse } from '../../modules/surveyResponse.js';
import OrgSettingsHeader from '../../components/headers/PageHeaders/Organization/OrganizationHeader.jsx';
import DownloadReportIcon from '../../components/icons/DownloadReportIcon.jsx';
import { formatedTemplate, generateSurveyPDF } from './utils/index.jsx';

const mapStateToProps = (state, { initiativeId, initiativeType }) =>
  createSelector(
    selectInitiative(initiativeId, initiativeType),
    (initiative) => ({
      initiative,
      initiativeId,
      initiativeType,
      templates: selectTemplates(state),
      organizationId: selectCurrentOrganizationId(state),
      organization: selectOrganization(state),
    })
  )(state);

const mapDispatchToProps = (
  dispatch,
  { initiativeId, initiativeType, surveyResponseId }
) =>
  bindActionCreators(
    {
      retrieveInitiative: () =>
        retrieveInitiative(initiativeType, initiativeId),
      retrieveSurveyResponse: () => retrieveSurveyResponse(surveyResponseId),
      applyChangeInsight,
      deleteSurveyFromInitiative,
      sendChangeInsightSurvey,
      retrieveTemplatesFeedbackForm,
      retrieveChangeInsight,
      retrieveOrganization,
      sendResponseSurvey,
    },
    dispatch
  );

const ChangeInsightsSurveyContainer = ({
  slug,
  retrieveChangeInsight,
  retrieveTemplatesFeedbackForm,
  organization,
  organizationId,
  retrieveOrganization,
  sendResponseSurvey,
  disabled,
  templateId,
  isPreview,
  isPreviewTemplate,
  templates,
}) => {
  const currentUrl = window.location.href;
  const searchParams = new URLSearchParams(new URL(currentUrl).search);

  const token = searchParams.get('token');
  const [surveyTemplate, setSurveyTemplate] = useState(null);
  const urlObject = new URL(currentUrl);
  const path = urlObject.pathname;

  const pathSegments = path.split('/');
  const surveyId = pathSegments[pathSegments.length - 1];

  const onSubmit = (answers) => {
    if (token) {
      sendResponseSurvey({ surveyResponse: { surveyResult: answers } }, token);
    }
  };

  useEffect(() => {
    if (isPreview) {
      const draftTemplateStr = localStorage.getItem('draftTemplate');
      if (draftTemplateStr) {
        let draftObj = null;
        try {
          draftObj = JSON.parse(draftTemplateStr);
        } catch (e) {
          draftObj = null;
        }
        const parsedSurveyJson = draftObj
          ? formatedTemplate(draftObj) || draftObj.surveyJson || null
          : null;
        if (parsedSurveyJson && parsedSurveyJson.pages) {
          const updatedWithoutRequired = parsedSurveyJson.pages.map((page) => {
            if (page.elements) {
              const updatedPage = page.elements.map((element) => ({
                ...element,
                isRequired: false,
              }));
              return { ...page, elements: updatedPage };
            }
            return { ...page };
          });
          setSurveyTemplate({
            ...(draftObj || {}),
            surveyJson: { ...parsedSurveyJson, pages: updatedWithoutRequired },
          });
        }
      }
    } else if (templateId) {
      retrieveTemplatesFeedbackForm();
    } else {
      retrieveChangeInsight(surveyId).then((res) => {
        const parseTemplate = formatedTemplate(res);
        setSurveyTemplate({ ...res, surveyJson: parseTemplate });
      });
    }
  }, []);

  useEffect(() => {
    if (templateId && templates) {
      const templateView = templates.find((t) => t.id === templateId);
      if (templateView) {
        const templateJson = formatedTemplate(templateView);
        if (templateJson && templateJson.pages) {
          const updatedWithoutRequired = templateJson.pages.map((page) => {
            if (page.elements) {
              const updatedPage = page.elements.map((element) => {
                return {
                  ...element,
                  isRequired: false,
                };
              });
              return { ...page, elements: updatedPage };
            }
            return { ...page };
          });
          setSurveyTemplate({
            ...templateView,
            surveyJson: { ...templateJson, pages: updatedWithoutRequired },
          });
        }
      }
    }
  }, [templateId, templates]);

  useEffect(() => {
    if (organizationId) {
      retrieveOrganization(organizationId);
    }
  }, [organizationId]);

  const headerTitle = {
    edit: 'Edit Feedback Form',
    new: 'Add Feedback Form',
    view: 'Feedback Form',
  };

  return (
    <React.Fragment>
      {organization ? (
        <OrgSettingsHeader
          slug={slug}
          page={isPreview ? headerTitle[isPreview] : headerTitle.view}
          canManageCustomSettings={organization.canManageCustomSettings}
        />
      ) : null}
      <SubHeader flexJustify>
        <div className="flex flex-justify w-100">
          <h2>
            Feedback Form
            {isPreview ? ' Preview' : ''}
          </h2>
          <div className="actions">
            <DropdownButton
              noCaret
              title=""
              id="id"
              className="btn-more btn btn-default"
            >
              <span className="item">
                <MenuItem
                  onClick={() =>
                    generateSurveyPDF({
                      title: surveyTemplate.title,
                      surveyJson: surveyTemplate.surveyJson,
                    })
                  }
                >
                  <span className="flex">
                    <DownloadReportIcon />
                    <span>&nbsp; Download Template</span>
                  </span>
                </MenuItem>
                <MenuItem divider />
              </span>
            </DropdownButton>
          </div>
        </div>
      </SubHeader>
      {surveyTemplate ? (
        <Form
          component={SurveyCompleteForm}
          onSubmit={onSubmit}
          handleSubmit={onSubmit}
          organization={organization}
          disabled={disabled}
          isPreviewTemplate={isPreviewTemplate}
          isPreview={isPreview}
          survey={surveyTemplate}
        />
      ) : null}
    </React.Fragment>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangeInsightsSurveyContainer);
